import React from "react";
import { Bar } from "react-chartjs-2";
import ChartCard from "../ChartCard";
import { withAgeGroupDistributionStyles } from "../chartStyles";

const AgeGroupDistributionChart = ({ ageGroupDistributionChart }) => {
  const values = ageGroupDistributionChart.data.datasets[0].data;
  const total = values.reduce((sum, value) => sum + value, 0);

  return (
    <ChartCard chart={ageGroupDistributionChart}>
      <Bar
        data={withAgeGroupDistributionStyles(ageGroupDistributionChart.data)}
        options={{
          indexAxis: "y",
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            x: {
              beginAtZero: true,
              ticks: {
                precision: 0,
              },
            },
          },
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              callbacks: {
                label: function (context) {
                  const count = Number(context.raw);
                  const percentage = total > 0 ? (count / total) * 100 : 0;
                  const formattedPercentage = new Intl.NumberFormat(undefined, {
                    maximumFractionDigits: 1,
                  }).format(percentage);

                  return `${context.dataset.label}: ${count} (${formattedPercentage} %)`;
                },
              },
            },
          },
        }}
      />
    </ChartCard>
  );
};

export default AgeGroupDistributionChart;
